
document.addEventListener('DOMContentLoaded', function () {
  //////////////Wishlist///////////////////////

  // window.addEventListener('load', function () {
  //   var countEl = document.querySelector('.st-wishlist-details-button .st-number');
  //   if (countEl) {
  //     var count = countEl.getAttribute('data-count');
  //     alert('Wishlist count: ' + count);
  //   } else {
  //     alert('Wishlist count element not found');
  //   }
  // });






  // (function () {
  //   function updateWishlistCount(count) {
  //     document.querySelectorAll('.wishlist_count').forEach(function (el) {
  //       el.textContent = count;
  //     });
  //   }

  //   function bindToSourceElement(sourceEl) {
  //     updateWishlistCount(sourceEl.getAttribute('data-count') || '0');
  //     var observer = new MutationObserver(function (mutations) {
  //       mutations.forEach(function (m) {
  //         if (m.attributeName === 'data-count') {
  //           updateWishlistCount(sourceEl.getAttribute('data-count') || '0');
  //         }
  //       });
  //     });
  //     observer.observe(sourceEl, { attributes: true });
  //   }

  //   function waitForWishlistButton() {
  //     var sourceEl = document.querySelector('.st-wishlist-details-button .st-number');
  //     if (sourceEl) {
  //       bindToSourceElement(sourceEl);
  //       return;
  //     }
  //     var domObserver = new MutationObserver(function (mutations, obs) {
  //       var el = document.querySelector('.st-wishlist-details-button .st-number');
  //       if (el) {
  //         obs.disconnect();
  //         bindToSourceElement(el);
  //       }
  //     });
  //     domObserver.observe(document.body, { childList: true, subtree: true });
  //   }

  //   window.addEventListener('load', waitForWishlistButton);
  // })();


(function () {
  function updateWishlistCount(count) {
    document.querySelectorAll('.wishlist_count').forEach(function (el) {
      if (!count || count === '0') {
         el.style.visibility = 'hidden';
      } else {
        el.textContent = count;
        el.style.visibility = 'visible';
      }
    });
  }

  function checkWishlist() {
    var source = document.querySelector('.st-wishlist-details-button .st-number');

    if (source) {
      updateWishlistCount(source.getAttribute('data-count') || '');

      var observer = new MutationObserver(function () {
        updateWishlistCount(source.getAttribute('data-count') || '');
      });

      observer.observe(source, {
        attributes: true,
        attributeFilter: ['data-count']
      });
    }
  }

  window.addEventListener('load', checkWishlist);
})();



  


  //////////////////////
  $(".bv-collection-slider").owlCarousel({
    items: 5,
    margin: 18,
    loop: false,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 500,
    navText: ["<span>&lsaquo;</span>", "<span>&rsaquo;</span>"],
    responsive: {
      0: {
        items: 1,
        margin: 12,
      },
      480: {
        items: 2,
        margin: 14,
      },
      768: {
        items: 3,
        margin: 16,
      },
      1024: {
        items: 4,
        margin: 18,
      },
      1200: {
        items: 5,
        margin: 18,
      },
    },
  });

  $(function () {
  var $slider = $('.sli_one');
  var $wrap   = $slider.closest('.sli_wrap');
 
  // show arrows only when the links are wider than the available space
  function checkOverflow() {
    $wrap.removeClass('no-overflow');
    var stageW = $slider.find('.owl-stage').outerWidth();
    var outerW = $wrap.width() - 88;                  // wrapper minus arrow padding (2 x 44)
    var fits   = stageW <= $wrap.width();             // fits even without arrows
    $wrap.toggleClass('no-overflow', fits);
    if (fits) { $slider.trigger('to.owl.carousel', [0, 0]); }
  }
 
  $slider.on('initialized.owl.carousel resized.owl.carousel refreshed.owl.carousel', checkOverflow);
 
  $slider.owlCarousel({
    autoWidth: true,       // each link keeps its natural width = one line
    items: 1,
    margin: 10,
    loop: false,
    dots: false,
    nav: true,
    navText: ['&#8249;', '&#8250;'],
    slideBy: 3,
    smartSpeed: 400,
    mouseDrag: true,
    touchDrag: true
  });
 
  // re-measure once fonts/images are loaded
  $(window).on('load', function () { $slider.trigger('refresh.owl.carousel'); });
});


// redirect to child link

   const normalize = (path) => path.replace(/\/+$/, '') || '/';
  const currentPath = normalize(window.location.pathname);

  const parentItems = document.querySelectorAll('.navigation__item--with-children');

  parentItems.forEach(function (parentItem) {
    const parentLink = parentItem.querySelector(':scope > .navigation__link');
    const childLinks = parentItem.querySelectorAll('.navigation__tier-2 .navigation__link');

    // 1) Mark parent + matching child as active for the current page
    childLinks.forEach(function (childLink) {
      const href = childLink.getAttribute('href');
      if (!href || href === '#') return;

      const linkPath = normalize(new URL(childLink.href, window.location.origin).pathname);

      // exact match, or a deeper page inside it (e.g. /collections/anaya/products/xyz)
      if (currentPath === linkPath || currentPath.startsWith(linkPath + '/')) {
        childLink.closest('.navigation__item').classList.add('navigation__item--active');
        parentItem.classList.add('navigation__item--active');
      }
    });

    // 2) Parent link with href="#" goes to its first child link
    if (parentLink && parentLink.getAttribute('href') === '#') {
      parentLink.addEventListener('click', function (event) {
        const firstChildLink = parentItem.querySelector(
          '.navigation__tier-2 .navigation__item:first-child .navigation__link'
        );

        if (firstChildLink) {
          event.preventDefault();
          window.location.href = firstChildLink.href;
        }
      });
    }
  });

})


////////////remove spaces////////////////////////////////////////////

    document.addEventListener('DOMContentLoaded', function () {
      function formatMoney() {
          document.querySelectorAll('span.money').forEach(function (element) {
            element.innerHTML = element.innerHTML.replace(/₹\s+/g, '₹').replace(/\s+INR\s*$/i, '');
          });
        }

        // Wait for currency/app to finish rendering
        setTimeout(function () {
          formatMoney();
        }, 1000);

        const observer = new MutationObserver(function () {
          // Wait for the dynamically updated price
          setTimeout(function () {
            formatMoney();
          }, 500);
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      });
